import { useQuery } from '@tanstack/react-query';

import { Subscriptions } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { buildEnhancedSubscription, type EnhancedSubscription } from '~/utils/SubscriptionUtils';

export { type EnhancedSubscription, PAID_PLANS, PRO_PLANS } from '~/utils/SubscriptionUtils';

export const SUBSCRIPTION = 'SUBSCRIPTION';

export const getSubscriptionKey = (workspaceId?: string) => {
  return workspaceId ? [SUBSCRIPTION, { workspaceId }] : [SUBSCRIPTION];
};

export const useSubscription = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const subscriptionKey = getSubscriptionKey(currentWorkspace?.id);

  return useQuery<EnhancedSubscription>({
    queryKey: subscriptionKey,

    queryFn: async () => {
      const workspaceId = currentWorkspace?.id;

      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      const subscription = await Subscriptions.get({ workspaceId });

      return buildEnhancedSubscription(subscription);
    },
    staleTime: Infinity,
    enabled: !!currentWorkspace?.id,
  });
};
